import { WARP_ME_EXTERNAL_LINKS } from "@warpme/ui"
import type { FC } from "react"

export const TenantFooter: FC = () => {
  return (
    <footer className="border-t border-border bg-bg-white">
      <div className="flex flex-col items-center gap-3 px-4 pb-5 pt-[52px]">
        <div className="flex items-center gap-1.5">
          <span className="h-6 w-6 rounded-full bg-[#f34a0c]" aria-hidden="true" />
          <span className="text-[20px] font-semibold leading-[1.35] text-foreground">WarpMe</span>
        </div>
        <p className="text-center text-[11px] font-light leading-[1.35] text-[#737373]">©WarpMe All Rights Reserved.</p>
      </div>
      <div className="border-t border-border px-4 py-3">
        <a href={WARP_ME_EXTERNAL_LINKS.corporateSite} className="text-center text-[11px] leading-[1.35] text-foreground" target="_blank" rel="noopener noreferrer">
          warpme.jp
        </a>
      </div>
    </footer>
  )
}
